import { ApiMenuData } from '../types';
import { getMenuEndpoint, getApiHeaders } from '../config/api';
import testData from '../data/test.json';

export class ApiService {
  private static instance: ApiService;

  private constructor() {}

  public static getInstance(): ApiService {
    if (!ApiService.instance) {
      ApiService.instance = new ApiService();
    }
    return ApiService.instance;
  }

  /**
   * Fetch menu data from the API
   */
  async fetchMenuData(): Promise<ApiMenuData> {
    try {
      const endpoint = getMenuEndpoint();
      const headers = getApiHeaders();

      console.log('Fetching menu data from:', endpoint);
      
      const response = await fetch(endpoint, {
        method: 'GET',
        headers,
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status} - ${response.statusText}`);
      }

      const data: ApiMenuData = await response.json();
      
      console.log('Menu data fetched successfully:', {
        totalRecords: data.totalRecords,
        numberOfRecords: data.numberOfRecords
      });

      return data;
    } catch (error) {
      console.error('Error fetching menu data from API:', error);
      
      // Fallback to test data if API fails
      console.log('Falling back to test data...');
      return testData as ApiMenuData;
    }
  }

  /**
   * Get test data (for development/testing)
   */
  getTestData(): ApiMenuData {
    return testData as ApiMenuData;
  }

  /**
   * Check if API is available
   */
  async checkApiHealth(): Promise<boolean> {
    try {
      const endpoint = getMenuEndpoint();
      const headers = getApiHeaders();

      const response = await fetch(endpoint, {
        method: 'HEAD', // Use HEAD to check without downloading full data
        headers,
      });

      return response.ok;
    } catch (error) {
      console.error('API health check failed:', error);
      return false;
    }
  }
}

// Export singleton instance
export const apiService = ApiService.getInstance();
export default apiService; 